<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css" integrity="sha512-Kc323vGBEqzTmouAECnVceyQqyqdsSiqLQISBL29aUW4U/M7pSPA/gEUZQqv1cwx4OnYxTxve5UMg5GT6L4JJg==" crossorigin="anonymous" referrerpolicy="no-referrer" />

<section class="hero-section ptb-120 text-white " style="background: url('../../../assets/images/newsLogos/hero-dot-bg.png')no-repeat center right">
  <div class="container">
      <div class="row align-items-center">
          <div class="col-lg-6 col-md-10">
              <div class="hero-content-wrap mt-5 mt-lg-0 mt-xl-0">
                  <h1 class="fw-bold display-5 ">{{'data_driven_connections1' | translate}} <br> <app-typing-component [textToType]="'fingertips' | translate"></app-typing-component></h1>
                  <p class="lead">{{'touch_connect_bio_link' | translate }}</p>
                  <div class="action-btn mt-5 align-items-center d-block d-sm-flex d-lg-flex d-md-flex">
                      <a routerLink="/login" class="btn btn-lg  py-3 rounded-4  shadow px-5 me-3" style="background-color:rgb(108,230,130);border-radius: 40px !important;color: #000;">{{'JOIN_TOUCH_CONNECT' | translate}}</a>

                  </div>

              </div>
          </div>
          <div class="col-lg-6 col-md-8 mt-5">
              <div class="hero-img position-relative circle-shape-images">
                  <!--animated shape start-->
                  <ul class="position-absolute animate-element parallax-element circle-shape-list">
                      <li class="layer" data-depth="0.03">
                          <img src="../../../assets/images/newsLogos/circle-1.svg" alt="shape" class="circle-shape-item type-0 hero-1">
                      </li>
                      <li class="layer" data-depth="0.02">
                          <img src="../../../assets/images/newsLogos/circle-1.svg" alt="shape" class="circle-shape-item type-1 hero-1">
                      </li>
                      <li class="layer" data-depth="0.04">
                          <img src="../../../assets/images/newsLogos/circle-1.svg" alt="shape" class="circle-shape-item type-2 hero-1">
                      </li>
                      <li class="layer" data-depth="0.04">
                          <img src="../../../assets/images/newsLogos/circle-1.svg" alt="shape" class="circle-shape-item type-3 hero-1">
                      </li>
                      <li class="layer" data-depth="0.03">
                          <img src="../../../assets/images/newsLogos/circle-1.svg" alt="shape" class="circle-shape-item type-4 hero-1">
                      </li>
                      <li class="layer" data-depth="0.03">
                          <img src="../../../assets/images/newsLogos/circle-1.svg" alt="shape" class="circle-shape-item type-5 hero-1">
                      </li>
                  </ul>
                  <!--animated shape end-->
                  <img src="../../../assets/images/Group 2.png" alt="hero img" class="img-fluid position-relative z-5 box">

              </div>
          </div>

      </div>
  </div>

</section>


<section class="hero-section ptb-120 position-relative overflow-hidden bg-white" style="background: url('../../../assets/images/newsLogos/color-particles-2.svg')no-repeat center top">
  <div class="container">
      <div class="row justify-content-center text-center">

          <div class="col-xl-8 col-lg-10 mb-5">
              <div class="hero-content-wrap">
                  <h1 class="fw-bold display-5 ail-highlighted-text">{{'ENHANCING_YOUR' | translate}} <app-typing-component [textToType]="'BUSINESS_NETWORK' | translate"></app-typing-component></h1>
                  <h4>{{'data_driven_connections_growth' | translate}}</h4>
                  <p class="lead" >{{'touch_connect_description'| translate}}</p>
                  <div class="action-btns text-center pt-4" >
                      <a routerLink="/login" class="btn btn-primary me-lg-3 me-sm-3">{{'STARTS_FREE_WITH_TOUCHCONNECT' | translate}}</a>
                  </div>
              </div>
          </div>

          <div class="col-lg-9">
              <div class="position-relative" >
                  <ul class="position-absolute animate-element parallax-element widget-img-wrap z-2">
                      <li class="layer" >
                          <img src="../../../assets/images/Linktree/ycard.png" alt="widget-img" class="img-fluid widget-img-1 position-absolute  rounded-custom">
                      </li>
                      <li class="layer" >
                          <img src="../../../assets/images/Mobile/2.PNG" alt="widget-img" class="img-fluid widget-img-3 position-absolute shadow-lg rounded-custom">
                      </li>
                  </ul>
                  <img src="../../../assets/images/Mobile/Section (4).png" alt="dashboard image" class="img-fluid position-relative rounded-custom mt-lg-5 box">
              </div>
          </div>
      </div>
  </div>

</section> <!--hero section end-->

